import React, { useEffect, useState } from 'react'

/**
 * This is a partial that renders the last-updated date on the detail pages.
 * There are a few occurrences of this now and it made sense to convert into something
 * that is reusable.
 * @param date
 * @param type
 * @returns {JSX.Element}
 * @constructor
 */

export default function LastUpdated({ lastUpdated, type="long" }) {
    const [format, setFormat] = useState('');

    useEffect(() => {
        if (lastUpdated) {
            const date = new Date(lastUpdated);
            let _date = date.toLocaleDateString('en', { day: 'numeric', month: 'long'});
            let _year = date.toLocaleDateString('en', { year: 'numeric', hour12: true });
            let _time = date.toLocaleTimeString('en', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
            let _format = '';

            if (type === 'long') {
                _format = `${_date}, ${_year} ${_time}`;
            }
            else if (type === 'medium') {
                _date = date.toLocaleDateString('en', { day: 'numeric', month: 'short'});
                _format = `${_date}, ${_year} ${_time}`;
            }
            else {
                _format = 'Invalid Date';
            }
            setFormat(_format);
        }
    }, [lastUpdated, type])

    return (
        <time> {format} </time>
    )
}
